import YTPlayer from '../../scripts/components/YTPlayer';
import { initInstallationSlider } from '../../snippets/installation-slider/installation-slider';
import { initCollapsibleRows } from '../../snippets/collapsible-rows/collapsible-rows';

initCollapsibleRows();
YTPlayer.init();
initInstallationSlider();
